import React from 'react';
import PropTypes from 'prop-types';

import { Cover, FAQs, Layout, MaintainerTextMedia, SEO, SectionReviewModals } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from 'utils/media';

import contentSEO from "cms/content/guarantee-seo.yml";
import contentCover from "cms/content/maintainer-plan-cover.yml";
import contentGuarantee from "cms/content/maintainer-plan-guarantee.yml";
import contentFaqs from "cms/content/maintainer-plan-faqs.yml"
import contentFaqs2 from "cms/content/maintainer-plan-faqs-2.yml"
import contentSecReviewModals from "cms/content/maintainer-plan-review-modals.yml";

const MaintainerPlanPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Cover
      title={contentCover.title}
      text={contentCover.text}
      image={{ url: media(contentCover.image) , alt: contentCover.title }}
      button={{ label: cta.getStarted, ...routes.getStarted }}
    />

    <MaintainerTextMedia 
      enabled={contentGuarantee.enabled}
      title={contentGuarantee.title}
      text={contentGuarantee.text}
      image={{ url: media(contentGuarantee.image) , alt: contentGuarantee.title }}
      priceUk={contentGuarantee.priceUk}
      priceEn={contentGuarantee.priceEn}
      priceSe={contentGuarantee.priceSe}
      locale={locale}
      className="small-media"
    />

    {contentFaqs.enabled && <FAQs title='Before getting started' faqsData={contentFaqs['faqs']}  locale={locale} />}

    {contentFaqs2.enabled && <FAQs title='' faqsData={contentFaqs2['faqs']} className='mb-90 mt-90 inc-font-size'  locale={locale} />}

    <SectionReviewModals content={contentSecReviewModals} />

  </Layout>
);

MaintainerPlanPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default MaintainerPlanPage;
